import _t from 'i18n!nls/my-purchases-graphql';

export default () => ({
  s12nFreeTrial: _t(
    `If you cancel during your free trial to {productName},
    your course content will become unavailable at the end of the trial period.`
  ),

  courseraLiteOrPlusFreeTrial: _t(
    `If you cancel during your free trial for {productName}, you won't be able to access course content after your free trial period ends.`
  ),

  s12nRefundSubscription: _t(
    `If you cancel your subscription to {productName}, you will
    be refunded your payment and your course content will become unavailable.`
  ),

  s12nCancelSubscription: _t('If you cancel, your course content will be unavailable starting {date}'),

  s12nCancelSubscriptionWithDiscount: _t(
    'If you continue your learning program, we’ll take {discount} your next bill. If you cancel your subscription instead, your access to {productName} will end at the conclusion of your billing period.'
  ),

  courseraPlusCancelSubscription: _t(`If you cancel your {productName} subscription, you will no longer have unlimited
    access to {numberOfProducts} courses, Guided Projects, Specializations, and Professional Certificates starting on {date}.`),

  courseraLiteCancelSubscription: _t(
    `If you cancel your {productName} subscription, you will no longer have unlimited access to videos and lectures in over 90% of courses, Specializations, and Professional Certificates starting on {date}.`
  ),

  catalogFreeTrial: _t(
    `If you cancel your subscription, you will lose access to graded course
    content at the end of the trial period, and you won't be able to earn Course Certificates.
    All of the content currently displayed on your dashboard will be lost and can not be saved or
    restored. All progress made in current courses will be saved and preserved if you choose to
    re-enroll at a later time.`
  ),

  catalogSubscription: _t(
    `If you cancel your subscription, you will lose access to graded course
    content on {date}, and you won't be able to earn Course Certificates.
    All of the content currently displayed on your dashboard will be lost and can not be saved or
    restored. All progress made in current courses will be saved and preserved if you choose to
    re-enroll at a later time.`
  ),
});
